export const setWorking = (bool) => ({
  type: 'set_working',
  data: bool,
});

export const setData = (data) => ({
  type: 'set_data',
  data,
});
